import type { ReactNode } from 'react';
import type { FilterFieldOption } from '~/components/ui';
import { FilterRowsPanel } from '~/components/ui/FilterRowsPanel';
import type { InventoryFilterRow } from '~/pages/buyer-inventory/lib/buyerInventoryFilterStorage';
import {
  initialInventoryValueFor,
  newInventoryFilterRow,
} from '~/pages/buyer-inventory/lib/inventoryFilterFields';

type InventoryFilterPanelProps = {
  readonly rows: InventoryFilterRow[];
  readonly fieldOptions: FilterFieldOption[];
  readonly maxHeight?: number;
  readonly bottomContent?: ReactNode;
  readonly onRowsChange: (rows: InventoryFilterRow[]) => void;
  readonly onClearAll: () => void;
};

export function InventoryFilterPanel({
  rows,
  fieldOptions,
  maxHeight,
  bottomContent,
  onRowsChange,
  onClearAll,
}: InventoryFilterPanelProps) {
  return (
    <FilterRowsPanel
      namespace="inventory"
      keyPrefix="inventory.filter"
      rows={rows}
      fieldOptions={fieldOptions}
      newRow={newInventoryFilterRow}
      initialValueFor={initialInventoryValueFor}
      valueInputFor={() => undefined}
      maxHeight={maxHeight}
      bottomContent={bottomContent}
      onRowsChange={onRowsChange}
      onClearAll={onClearAll}
    />
  );
}
